import React from 'react';

export const Toolbar = ({
  currentComponent
} : {
  currentComponent?: JSX.Element | null
}) => {

  return (
    currentComponent ? <div className="toolbar bg-black position-fixed text-light w-100 py-2" style={{ bottom: 0 }}>
      <div className='container animated slideInUp d-flex flex-row justify-content-between'>
        {currentComponent}
      </div>
    </div> : null
  )
}